import React from 'react';
import { Box, Flex, Heading, Stack, SkuBot, Text } from '@commonsku/design-system';
import { ChatInput } from '../skubot/ChatInput';

export const PRESENTATION_CHAT_PLACEHOLDER = 'Tell skubot what to do next...';
export const PRESENTATION_CHAT_DISCLAIMER =
  'Skubot can make mistakes. Please double-check responses.';

const CONNECTED_PLUS_BANNER =
  'skubot only searches connected+ products, so every result comes with verified data and full configuration options.';

const STARTING_STATE_TITLE = "What's next for this presentation?";
const STARTING_STATE_SUBTITLE =
  'Search the catalog, add or swap products, or remove items — just describe what you need.';

export type PresentationChatStartingStateProps = {
  input: string;
  onInputChange: (value: string) => void;
  onSend: (message?: string) => void;
  disabled?: boolean;
  className?: string;
  hasProducts?: boolean;
};

export function PresentationChatStartingState({
  input,
  onInputChange,
  onSend,
  disabled = false,
  className,
  hasProducts = false,
}: PresentationChatStartingStateProps) {
  return (
    <Flex className={className} flex="1" minH={0} direction="column">
      <Box flex="1" minH={0} overflowY="auto" w="full">
        <Flex
          className="skubot-welcome-content"
          align="center"
          justify="center"
          px="16px"
          py="24px"
          minH="100%"
        >
          <Stack w="full" align="center" gap="12px" textAlign="center">
            <Box
              w="48px"
              h="48px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <SkuBot color="skuBlue.600" height="48px" width="48px" />
            </Box>

            <Box gap="4px">
              <Heading as="h1" fontSize="sm" fontWeight="semibold" color="gray.900" margin="0">
                {STARTING_STATE_TITLE}
              </Heading>

              <Text
                margin="0"
                fontSize="sm"
                lineHeight="20px"
                color="gray.600"
                maxW="320px"
              >
                {STARTING_STATE_SUBTITLE}
              </Text>
            </Box>
          </Stack>
        </Flex>
      </Box>

      <Box className="skubot-chat-input-section" w="full" bg="#fafafa" pb="16px">
        <Stack
          className="skubot-chat-input"
          w="full"
          align="center"
          gap="16px"
          px="16px"
        >
          <Box
            w="full"
            bg="skuBlue.50"
            borderRadius="6px"
            p="8px"
            border="1px solid"
            borderColor="skuNavy.200"
            backgroundColor="skuNavy.100"
          >
            <Text
              margin="0"
              fontSize="xs"
              lineHeight="16px"
              color="skuNavy.700"
            >
              {CONNECTED_PLUS_BANNER}
            </Text>
          </Box>

          <ChatInput
            value={input}
            onChange={onInputChange}
            onSubmit={() => onSend()}
            placeholder={PRESENTATION_CHAT_PLACEHOLDER}
            disabled={disabled}
            minH="70px"
            borderColor="gray.200"
          />

          <Text
            margin="0"
            fontSize="xs"
            lineHeight="16px"
            color="gray.600"
          >
            {PRESENTATION_CHAT_DISCLAIMER}
          </Text>
        </Stack>
      </Box>
    </Flex>
  );
}
